(function () {
  'use strict';

  var LENS_SIZE = 250;
  var ZOOM      = 2.5;

  function injectStyles() {
    if (document.getElementById('pim-styles')) return;
    var s = document.createElement('style');
    s.id = 'pim-styles';
    s.textContent =
      '.pim-lens{' +
        'position:absolute;' +
        'width:' + LENS_SIZE + 'px;' +
        'height:' + LENS_SIZE + 'px;' +
        'border-radius:50%;' +
        'border:2.5px solid rgba(255,255,255,0.9);' +
        'box-shadow:0 0 0 1px rgba(0,0,0,0.15),0 8px 30px rgba(0,0,0,0.25);' +
        'pointer-events:none;' +
        'overflow:hidden;' +
        'display:none;' +
        'z-index:9999;' +
        'transform:translate(-50%,-50%);' +
      '}' +
      '.pim-lens.active{display:block;}' +
      '.pim-lens img{' +
        'position:absolute;' +
        'pointer-events:none;' +
        'max-width:none !important;' +
        'max-height:none !important;' +
      '}' +
      '.pim-lens::before,.pim-lens::after{' +
        'content:"";position:absolute;' +
        'background:rgba(255,255,255,0.3);' +
        'pointer-events:none;' +
      '}' +
      '.pim-lens::before{width:1px;height:100%;left:50%;}' +
      '.pim-lens::after{width:100%;height:1px;top:50%;}' +
      /* hide the expand icon and modal toggle button */
      '.pim-host .product__media-icon{display:none !important;}' +
      '.pim-host .product__media-toggle{display:none !important;}' +
      '.pim-host{position:relative !important;cursor:crosshair !important;}';
    document.head.appendChild(s);
  }

  function blockEvent(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  function attach(opener) {
    if (opener._pimDone) return;
    opener._pimDone = true;

    opener.classList.add('pim-host');

    /* ── Block modal on ALL devices ── */
    opener.addEventListener('click',      blockEvent, true);
    opener.addEventListener('touchend',   blockEvent, true);

    var toggle = opener.querySelector('.product__media-toggle');
    if (toggle) {
      toggle.addEventListener('click',    blockEvent, true);
      toggle.addEventListener('touchend', blockEvent, true);
    }

    function getImg() {
      return opener.querySelector('.product__media img, .media img, img');
    }

    /* create lens */
    var lens = document.createElement('div');
    lens.className = 'pim-lens';
    var lensImg = document.createElement('img');
    lensImg.alt = '';
    lensImg.setAttribute('aria-hidden', 'true');
    lens.appendChild(lensImg);
    opener.appendChild(lens);

    /* ── shared move logic for both mouse and touch ── */
    function moveLens(clientX, clientY) {
      var img = getImg();
      if (!img || !img.naturalWidth) return;

      var rect   = opener.getBoundingClientRect();
      var posX   = clientX - rect.left;
      var posY   = clientY - rect.top;

      /* clamp so lens stays inside the image */
      posX = Math.max(0, Math.min(posX, rect.width));
      posY = Math.max(0, Math.min(posY, rect.height));

      lens.style.left = posX + 'px';
      lens.style.top  = posY + 'px';

      var scaleX = (img.naturalWidth  / img.offsetWidth)  * ZOOM;
      var scaleY = (img.naturalHeight / img.offsetHeight) * ZOOM;

      lensImg.style.width  = (img.offsetWidth  * scaleX) + 'px';
      lensImg.style.height = (img.offsetHeight * scaleY) + 'px';
      lensImg.style.left   = (-(posX * scaleX) + LENS_SIZE / 2) + 'px';
      lensImg.style.top    = (-(posY * scaleY) + LENS_SIZE / 2) + 'px';
    }

    function syncSrc() {
      var img = getImg();
      if (!img) return;
      var best = getBestSrc(img);
      if (lensImg.getAttribute('src') !== best) lensImg.src = best;
    }

    function getBestSrc(img) {
      if (img.srcset) {
        var parts = img.srcset.split(',').map(function (s) {
          var p = s.trim().split(/\s+/);
          return { url: p[0], w: parseInt(p[1]) || 0 };
        });
        parts.sort(function (a, b) { return b.w - a.w; });
        if (parts[0] && parts[0].url) return parts[0].url;
      }
      return img.src;
    }

    /* ── MOUSE events (desktop) ── */
    opener.addEventListener('mouseenter', function () {
      syncSrc();
      lens.classList.add('active');
    });

    opener.addEventListener('mouseleave', function () {
      lens.classList.remove('active');
    });

    opener.addEventListener('mousemove', function (e) {
      moveLens(e.clientX, e.clientY);
    });

    /* ── TOUCH events (mobile) ── */
    opener.addEventListener('touchstart', function (e) {
      e.preventDefault(); /* stop scroll & modal */
      syncSrc();
      lens.classList.add('active');
      var t = e.touches[0];
      moveLens(t.clientX, t.clientY);
    }, { passive: false });

    opener.addEventListener('touchmove', function (e) {
      e.preventDefault(); /* stop page scroll while magnifying */
      var t = e.touches[0];
      moveLens(t.clientX, t.clientY);
    }, { passive: false });

    opener.addEventListener('touchend', function (e) {
      e.preventDefault();
      lens.classList.remove('active');
    }, { passive: false });

    opener.addEventListener('touchcancel', function () {
      lens.classList.remove('active');
    });
  }

  function init() {
    injectStyles();

    var openers = document.querySelectorAll('modal-opener.product__modal-opener--image');
    if (openers.length === 0) {
      openers = document.querySelectorAll('.product__media-list modal-opener');
    }

    openers.forEach(function (el) { attach(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();